<template>
  <div class="multi type-band" v-on-display="{sectionInfo, context: this}">
    <div class="title">
      <h2 v-band-title class="title-area" tabindex="0">
        <span class="label">{{multiSectionTitle}}</span>
      </h2>
    </div>
    <div>
      <lazy-component @show="setData()">
        <swiper :options="swiperOptions" ref="cellListSwiper" class="swiper-container swiper swiper-container-horizontal">
          <swiper-slide v-for="(cell, index) in cellList" :key="index">
            <keyword-line2-cell :cell-info="cell"></keyword-line2-cell>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </lazy-component>
      <template v-if="hasViewMore">
        <a href="#" @click.prevent="viewMore(sectionInfo)" class="btn-more all">{{viewMoreTitle(sectionInfo, '더보기')}}</a>
      </template>
    </div>
  </div>
</template>
<script>
import { bandTitle, onDisplay } from '@/common/resources/directives'
import { isPrerenderer } from '@/common/utils/common'
import { fetchOnContent } from '@/common/utils/request.common'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getButtonInfo, getCellList } from '@/common/utils/gnb.fp'
import KeywordLine2Cell from '@/components/model/cell/KeywordLine2Cell'
import MultiSectionMixin from '@/mixins/multisection.mixin'

export default {
  name: 'TemplateKeywordBandLine2',
  mixins: [
    MultiSectionMixin
  ],
  components: {
    swiper,
    swiperSlide,
    KeywordLine2Cell
  },
  directives: { bandTitle, onDisplay },
  props: {
    sectionInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    }
  },
  data () {
    return {
      cellList: [],
      isPreRenderer: isPrerenderer(),
      swiperOptions: {
        width: 1240,
        // height: this.thumbnailInfo.height,
        spaceBetween: 10,
        slidesPerView: 5,
        slidesPerGroup: 5,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        observer: true
      }
    }
  },
  methods: {
    async setData () {
      if (this.cellList.length !== 0) return
      const response = await fetchOnContent(this.sectionInfo)
      this.cellList = getCellList(response)
      this.buttonInfo = getButtonInfo(response)
      if (this.cellList.length === 0) { this.isVisible = false }
    }
  },
  created () {
    if (this.isPreRenderer) {
      this.setData()
    }
  }
}
</script>
<style lang="css" src="@/assets/css/new_band.css"></style>
